/**
 * `/$org/compliance/probe`: Probe moved to Apps (one of Amoreg's own apps).
 * The old address redirects so bookmarks and links keep working.
 *
 * @module routes/$org.compliance.probe
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/$org/compliance/probe")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/$org/apps/probe", params: { org: params.org }, replace: true });
  },
});
